// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
const selectionButtonsIds = [
    'invalidate-btn',
    'close-runners-btn',
    'set-enabled-default-btn',
    'set-enabled-ignore-deps-btn',
    'set-enabled-disabled-btn',
    'expand-deps-btn',
    'expand-consumers-btn'
];
export function createSelectionBarController(options) {
    const updateSelectionUI = () => {
        const bar = document.getElementById('selection-bar');
        if (!bar)
            return;
        bar.style.display = 'flex';
        const headingSpan = document.getElementById('view-heading-text');
        if (headingSpan) {
            headingSpan.textContent =
                options.getCurrentView() === 'graph' ? 'Dependency Graph' : 'Operations Table';
        }
        const hasSelection = options.getSelection().size > 0;
        const connected = options.isConnected();
        selectionButtonsIds.forEach((id) => {
            const el = document.getElementById(id);
            if (el)
                el.disabled = !(hasSelection && connected);
        });
        const clearBtn = document.getElementById('clear-selection-btn');
        if (clearBtn) {
            clearBtn.disabled = !(hasSelection && connected);
            clearBtn.title = 'Clear selection';
            clearBtn.setAttribute('aria-label', 'Clear selection');
        }
        const countSpan = document.getElementById('selection-count');
        if (countSpan) {
            const count = options.getSelection().size;
            countSpan.textContent = count + (count === 1 ? ' selected' : ' selected');
        }
    };
    return {
        updateSelectionUI
    };
}
//# sourceMappingURL=selectionBar.js.map